// API base URL — set REACT_APP_API_URL in .env (dev) / .env.production (live)
export const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/$/, '');
